import { HttpInterceptorFn } from '@angular/common/http';
import {KeyStorageUtil} from '../../shared/utils/keystorage';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const token =    KeyStorageUtil.getItem<string>('token');


  if (req.url.includes('/api/login') && token) {
    return next(req);
  }

  if (token) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(authReq);
  }
  return next(req);
};
